export default "__VITE_ASSET__9f410400__"